import { createAsyncAction } from '../reduxActions';

export const scheduleWebinarAction = createAsyncAction('SCHEDULE_WEBINAR');

export function scheduleWebinar(organizerKey, webinarData, occurrenceType, copiedWebinarKey, selectedRecording, newExperience = false) {
  return {
    type: scheduleWebinarAction.toString(), organizerKey, webinarData, occurrenceType, copiedWebinarKey, selectedRecording, newExperience
  };
}
